<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('MODE_CONNEXION')">
        <slot name="section-mode-connexion">
          <section-mode-connexion ref="MODE_CONNEXION"
                                  id="MODE_CONNEXION"
                                  :extended="isExtended('MODE_CONNEXION')"
                                  :showButton="true"
                                  :autoSave="true"
                                  :readOnly="readOnly"
                                  :moduleId="moduleId"
                                  :searchText="searchText"
                                  :ressourceHeader="ressource"
                                  :fiche="fiche"
                                  :user=selectedUser
                                  :route="route"
                                  :attribut="attribut"
                                  @extended="setExtended"
                                  @fullscreen="setFullscreen"
                                  @status="updateStatus"
                                  @updated="userUpdated"
                                  @selectItem = "selectItem">
          </section-mode-connexion>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import Contact from '@/extend/classes/Contact';
import User from '@/extend/classes/User';
import { storeUser } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionModeConnexion from '@/custom/sections/SectionModeConnexion.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionModeConnexion,
    FicheHeader,
  },

  props: {
    contact: {
      type: Object as PropType<Contact>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.PREFERENCE,
      sections: [
        'MODE_CONNEXION',
      ],

      user: new User(),
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_PREFERENCE);
    },

    selectedContact (): Contact {
      return this.contact
    },
    selectedUser (): User {
      if (this.contact.id == 0) {
        return storeUser.createNewUser();
      } else {
        return storeUser.getUser(this.contact.id);
      }
    },

  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    userUpdated (user: User) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      return true;
    }
  }
})
</script>
